import * as angular from "angular";
import {IController} from "angular";
import {DeliverySchedulingForm} from "../../models/delivery-scheduling-form.model";
import {QuestionnaireElementType} from "../../types/questionnaire-element.type";
import {Address} from "../../../addresses/models/address.model";
import * as _ from "lodash"
import {QuestionnairePage} from "../../models/questionnaire-page.model";
import {SplitService} from "../../../commons/services/split-service.service";


export class DeliverySchedulingFormViewCtrl implements IController {

  deliverySchedulingForm: DeliverySchedulingForm;
  deliverySchedulingStateReference: any;
  onClose: Function;

  public destination: Address;
  public timeWindow: any;
  public notes: string;
  public questionsAndAnswers: { question: string, answer: string }[]
  private localCountryCode: string;

  /* @ngInject */
  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.localCountryCode = this.splitService.getLocaleCode();
    this.questionsAndAnswers = [];

    _.forOwn(this.deliverySchedulingForm?.answers, (answer: any) => {
      if (answer.type === QuestionnaireElementType.Address) {
        this.destination = answer.address
      } else if (answer.type === QuestionnaireElementType.TimeWindow) {
        this.timeWindow = answer.timeWindow;
      } else if (answer.type === QuestionnaireElementType.Notes) {
        this.notes = answer.notes;
      } else if (answer.type === QuestionnaireElementType.RadioGroup) {
        const page = _.find(this.deliverySchedulingForm.questionnaire.pages, (page: QuestionnairePage) => {
          return page.questions[0].id === answer.questionId;
        });
        const choice = _.find(page.questions[0].choices, (choice) => {
          return choice.id === answer.radioGroup
        });

        this.questionsAndAnswers.unshift({
          question: page.title ? page.title : page.questions[0].title,
          answer: choice.value
        });
      }
    })

  }

}

angular
  .module('bringoz.admin.oms')
  .component('deliverySchedulingFormView', {
    bindings: {
      deliverySchedulingForm: '<',
      deliverySchedulingStateReference: '<',
      onClose: '&'
    },
    template: require('./delivery-scheduling-form-view.html').default,
    controller: DeliverySchedulingFormViewCtrl
  });
